




















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { LineGroup, AddMachineToGroup } from '../store/line'
import { MachineOverview } from '../store/machine'

@Component
export default class LineForm extends Vue {
  @Prop() machines!: MachineOverview[]
  @Prop() placeholder!: LineGroup

  id = this.placeholder.id
  groupName: string = this.placeholder.groupName
  search = ''
  selected: MachineOverview[] = this.selectedMachine()

  valid = false
  private selectedMachine() {
    const m = this.placeholder.machines ? [...this.placeholder.machines] : []
    return m
  }

  get items() {
    const selectedMap = this.selected.reduce((acc, cur) => {
      return {
        ...acc,
        [cur.id]: cur
      }
    }, {} as { [key: string]: any })
    // show only machines that are not selected and do not have line group yet
    // if the machine has a line group but is the same as the current group then also show it
    return this.machines.filter(
      machine =>
        !selectedMap[machine.id] &&
        (!machine.lineGroup || machine.lineGroup === this.placeholder.groupName)
    )
  }
  get allSelected() {
    return this.items.length === 0
  }
  get categories() {
    const search = this.search.toLowerCase()

    if (!search) return this.items

    return this.items.filter(item => {
      const text = item.id.toLowerCase()
      return text.indexOf(search) > -1
    })
  }
  get selections() {
    return this.selected.map(i => i)
  }
  @Watch('selected')
  clearSearch() {
    this.search = ''
  }

  @Watch('placeholder')
  updateSelected() {
    this.selected = this.selectedMachine()
    this.search = ''
    this.id = this.placeholder.id
  }

  submit() {
    const id = this.id
    const machines = this.selected.map(m => m.id)
    const data: AddMachineToGroup = {
      id,
      machines
    }
    this.$emit('submit', data)
    this.search = ''
    this.id = ''
    this.selected = []
  }
  cancel() {
    this.$emit('cancel')
    this.search = ''
    this.selected = this.placeholder.machines
      ? ([] as MachineOverview[]).concat(this.placeholder.machines)
      : []
  }
}
